import { useQuery } from '@tanstack/react-query';

import { useMetaApiInstance } from '../api';
import { HOST_QUERY_KEY } from '../constants';

import type { UseQueryOptions } from '@tanstack/react-query';
import type { FavoriteService } from '../constants';

type UseFavoriteServiceOptions = Omit<UseQueryOptions<FavoriteService[]>, 'queryKey' | 'queryFn'>;

/**
 * 현재 사용자가 즐겨찾는 서비스 목록을 제공하는 훅입니다.
 * @description
 * - Meta Api의 응답값을 react-query로 제공합니다.
 * - SSR을 지원하고 있습니다.
 * - queryKey를 기반으로 revalidate 할 수 있습니다.
 */
const useFavoriteServiceState = (options?: UseFavoriteServiceOptions) => {
  const { fetchFavoriteService } = useMetaApiInstance();

  return useQuery<FavoriteService[]>({
    queryKey: [HOST_QUERY_KEY.GET_FAVORITE_SERVICE],
    queryFn: () => fetchFavoriteService(),
    staleTime: Infinity,
    ...options,
  });
};

export default useFavoriteServiceState;
